module.exports = __webpack_public_path__ + "img/steel_worker.547c0f80.png";